import React from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';

interface ImminenceDateProps {
  dateType: string;
  date: string;
  setStatusTwoDays: React.Dispatch<React.SetStateAction<boolean>>;
  setStatusOneDay: React.Dispatch<React.SetStateAction<boolean>>;
  setStatusDay: React.Dispatch<React.SetStateAction<boolean>>;
}

const ImminenceDate = (props: ImminenceDateProps) => {
  const { dateType, date, setStatusTwoDays, setStatusOneDay, setStatusDay } = props;

  moment.locale('pt-br');
  const new_date = moment(new Date(), 'DD/MM/YYYY');
  const new_date_one = moment(new Date(), 'DD/MM/YYYY');

  const date_two_day = new_date.add(2, 'days').format('DD/MM/YYYY');
  const date_one_day = new_date_one.add(1, 'days').format('DD/MM/YYYY');
  const date_bidding = moment.parseZone(date).format('DD/MM/YYYY');

  date_two_day === date_bidding && setStatusTwoDays(true);
  date_one_day === date_bidding && setStatusOneDay(true);
  moment(new Date()).format('DD/MM/YYYY') === date_bidding && setStatusDay(true);
  return <> {`${dateType}: ${moment.parseZone(date).format('DD/MM/YYYY HH:mm')}`} </>;
};

export default ImminenceDate;
